
const common = {
  // Navigation
  home: 'Home',
  about: 'About',
  services: 'Services',
  contact: 'Contact',
  events: 'Events',
  licenses: 'Licenses',
  
  // Hero Section
  heroTitle: 'Your Gateway to GCC Career Success',
  heroSubtitle: 'Professional Recruitment Services for Qatar, Oman, Kuwait, Saudi Arabia & UAE',
  heroDescription: 'With over 15 years of experience, we connect skilled professionals with top employers across the Gulf region. From healthcare to construction, hospitality to technology - we make your GCC career dreams a reality.',
  getStarted: 'Get Started',
  learnMore: 'Learn More',
  
  // Trust Indicators
  trustedBy: 'Trusted by',
  gccEmployers: 'Leading GCC Employers',
  certifiedAgency: 'Certified Agency',
  qualityAssured: 'Quality Assured',
  
  // Stats
  yearsExperience: 'Years Experience',
  successfulPlacements: 'Successful Placements',
  partnerCompanies: 'Partner Companies',
  countries: 'GCC Countries',
  
  // About Section
  aboutTitle: 'About Bicha Travels',
  aboutSubtitle: 'Your trusted partner for GCC employment opportunities',
  aboutDescription: 'Bicha Travels has been a leading recruitment agency specializing in GCC countries for over 15 years. We have successfully placed thousands of skilled professionals in various sectors including healthcare, construction, hospitality, and technology across Qatar, Oman, Kuwait, Saudi Arabia, and the UAE.',
  ourMission: 'Our Mission',
  missionText: 'To bridge the gap between talented professionals and leading employers in the GCC region, ensuring mutual success and long-term partnerships.',
  ourVision: 'Our Vision',
  visionText: 'To be the most trusted and preferred recruitment partner for GCC employment, known for our integrity, quality service, and successful placements.',
  
  // Services
  servicesTitle: 'Our Services',
  servicesSubtitle: 'Comprehensive recruitment solutions for GCC countries',
  hospitalityTitle: 'Hospitality & Tourism',
  hospitalityDesc: 'Connect with leading hotels, resorts, and tourism companies across the GCC region.',
  constructionTitle: 'Construction & Engineering',
  constructionDesc: 'Find opportunities in major infrastructure and construction projects in GCC countries.',
  medicalTitle: 'Healthcare & Medical',
  medicalDesc: 'Join top hospitals and healthcare facilities across Qatar, UAE, Saudi Arabia, Kuwait, and Oman.',
  technicalTitle: 'Technical & IT',
  technicalDesc: 'Explore technology and IT opportunities in the rapidly growing GCC tech sector.',
  
  // Documentation
  documentationTitle: 'Documentation Support',
  documentationList: [
    'Initial consultation and skills assessment',
    'Job matching with verified GCC employers',
    'Employment contract preparation and review',
    'Visa application and processing support',
    'Medical examination coordination',
    'Travel arrangements and pre-departure briefing'
  ],
  
  // Contact
  contactTitle: 'Contact Us',
  contactSubtitle: 'Get in touch with our experienced recruitment team',
  contactDescription: 'Ready to start your GCC career journey? Our team is here to guide you through every step of the process.',
  contactInfo: 'Contact Information',
  fullName: 'Full Name',
  emailAddress: 'Email Address',
  phoneNumber: 'Phone Number',
  subject: 'Subject',
  message: 'Message',
  sendMessage: 'Send Message',
  
  // Contact Details
  phoneLabel: 'Phone',
  emailLabel: 'Email',
  addressLabel: 'Address',
  phone1: '+91 98954 40243',
  phone2: '+91 80788 80074',
  phone3: '+91 80788 80074',
  email1: 'bdm@bichatravels.com',
  email2: 'mail@bichatravels.com',
  
  // Office Addresses - Updated with actual addresses
  officeAddress1: 'Door no. 61/849, 2nd Floor, P.K Complex, Cherootty Road, Calicut, Kerala, India- 673032',
  officeAddress2: '2nd Floor, Kmi Complex, Near Metro Piller 193, Muttom, Cochin, Kerala',
  officeAddress3: '4th Floor, Pearl Towers, Opposite Crown Plaza Hotel, Airport Street, Umm Ghuwailina, Doha, Qatar',
  officeAddress4: 'Kuwait City, Mirqab near Nesto Hypermarket, Kuwait City, Kuwait',
  
  // Offices
  ourOffices: 'Our Offices',
  headOffice: 'Head Office',
  branchOffice: 'Branch Office',
  branchOffice2: 'Branch Office',
  branchOffice3: 'Branch Office',
  
  // Licenses
  licensesTitle: 'Licenses & Certifications',
  licensesSubtitle: 'Fully authorized and certified recruitment agency',
  licenseNumber1: 'B-1701/KER/PER/1000+/5/9853/2021',
  licenseNumber2: 'MHA-2024-002',
  licenseNumber3: 'MHA-2024-003',
  
  // Footer
  quickLinks: 'Quick Links',
  followUs: 'Follow Us',
  allRightsReserved: 'All rights reserved.',
  
  // Common Actions
  // contact: 'Contact Us',
  readMore: 'Read More',
  viewAll: 'View All'
};

export default common;